export const theme = {
    colors: {
        // Tons Verde
        green: {
            Fundo: '#2FBB6914',
            Verde_AgroReceita: '#2FBB69', 
            Bandeira: '#06B04D',
            Folha: '#03903E'
        },
        
        // Tons Azul
        blue: {
            fundo: '#5BB3FF14',
            Azul_link: '#589BFF', 
            Ceu: '#5BB3FF',
        },

        // Tons Vermelho
        red: {
            fundo: '#FF525214',
            Vermelho_erro: '#FF5252', 
            Tostado: '#D9261D',
        },

        // Tons Laranja
        orange: {
            fundo: '#F89E4B14',
            Laranja_Sudeste: '#F89E4B', 
            Laranja: '#F4702C',
        },

        // Tons Amarelo
        yellow: {
            fundo: '#F8C84B1F',
            Amarelo: '#F8C84B', 
            Gema: '#F0B316',
        },

        // Tons Cinza
        gray: {
            fundo: '#21262F14',
            Cinza_1: '#1D2129',
            Cinza_2: '#21262F',
            Cinza_3: '#292E38',
            Cinza_4: '#2D3340',
            Cinza_5: '#303848',
            Cinza_6: '#586377',
            Cinza_7: '#8A92A2',
            Cinza_8: '#BAC1CF',
            Cinza_9: '#CED2DC',
            Cinza_10: '#DFE4EB',
            Cinza_11: '#E9ECF0',
            Cinza_12: '#F3F3F5',
            Cinza_13: '#F8F8F9',
        },

        // Tons Branco
        white: {
            Branco: '#FFFFFF',
        },

        // Tons Roxo
        purple: {
            Roxo_1: '#943a92',
        },

        // Tons Preto
        black: {
            Preto: '#000000',
        },

        // Fundo Desabilitado
        disabled: {
            Fundo_Desabilitado: '#EEEEEE',
            Desabilitado_Claro: '#BBBBBB',
            Desabilitado_Medio: '#AAAAAA',
        },
    },
    typography: {
        fontFamily: {
            primary: '"Lato", sans-serif',
            secondary: '"Roboto", sans-serif',
        },
        fontWeight: {
            light: 300,
            regular: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
            extraBold: 800
        },
        letterSpacing: {
            normal: '0.1rem'   // 1.6px (Base 16px)
        },
        fontSize: {
            display: '3rem',       // 48px (Base 16px)
            h1: '2.5rem',           // 40px
            h2: '2.25rem',          // 36px
            h3: '2rem',              // 32px
            h4: '1.75rem',           // 28px
            h5: '1.5rem',            // 24px
            h6: '1.25rem',           // 20px
            bodyG: '1.125rem',       // 18px
            bodyM: '1rem',           // 16px
            bodyP: '0.875rem',       // 14px
            auxiliar: '0.75rem',     // 12px
            minimo: '0.625rem',      // 10px
            tagLineG: '0.6875rem',   // 11px
            tagLineM: '0.625rem',    // 10px
            tagLineP: '0.5625rem',   // 9px
        },
        lineHeight: {
            display: '3.6rem',       // 57.6px (Base 16px)
            h1: '3.25rem',           // 52px
            h2: '2.925rem',          // 46.8px
            h3: '2.6rem',            // 41.6px
            h4: '2.275rem',          // 36.4px
            h5: '1.95rem',           // 31.2px
            h6: '1.625rem',          // 26px
            bodyG: '1.8rem',         // 28.8px
            bodyM: '1.6rem',         // 25.6px
            bodyP: '1.3125rem',      // 21px
            auxiliar: '1.125rem',    // 18px
            minimo: '0.9375rem',     // 15px
            tagLineG: '1.0313rem',   // 16.5px
            tagLineM: '0.9375rem',   // 15px
            tagLineP: '0.8438rem',   // 13.5px
        },
    },
    extend: {
        unit_size: {
            4: '0.25rem',   // 4px (Base 16px)
            8: '0.5rem',    // 8px
            12: '0.75rem',  // 12px
            16: '1rem',     // 16px
            24: '1.5rem',   // 24px
            32: '2rem',     // 32px
        },
        gap: {
            4: '0.25rem',   // 4px (Base 16px)
            8: '0.5rem',    // 8px
            12: '0.75rem',  // 12px
            16: '1rem',     // 16px
            24: '1.5rem',   // 24px
            32: '2rem',     // 32px
        },
    },
};
